<template>
  <li
    :class="[
      'pdl-steps__item relative block text-center whitespace-nowrap p-2 text-sm font-medium border-b border-gray-10 md:text-base after:w-6 after:h-6',
      {
        'pdl-steps__item--clickable': isClickable,
        'pdl-steps__item--current-step': isCurrentStep,
      },
    ]"
    :aria-current="ariaCurrentText"
    :qaid="qaid"
    @click="updateCurrentStep"
  >
    <!-- @slot Use for the content of the step. -->
    <component :is="componentTag" v-bind="componentAttrs" class="no-underline text-inherit">
      <slot />
    </component>
  </li>
</template>

<script>
import Key from './Key'; // This is a symbol that ensures our provide/inject is scoped to this singular usage of PdlSteps/PdlStepsItem

export default {
  name: 'PdlStepsItem',
  inject: {
    steps: Key,
  },
  data() {
    return {
      indexData: undefined,
    };
  },
  props: {
    stepUrl: {
      type: String,
      default: null,
    },
    qaid: {
      type: String,
      default: null,
    },
  },
  computed: {
    index: {
      get() {
        return this.indexData;
      },
      set(idx) {
        /**
         * Emitted whenever a PdlStepsItem's index is set, in case steps are added/removed after mount. Args: the index of the step.
         */
        this.$emit('update', idx);
      },
    },
    isClickable() {
      return this.steps.nonLinear ? this.index !== this.steps.currentStep : this.index < this.steps.currentStep;
    },
    isCurrentStep() {
      return this.steps.currentStep === this.index;
    },
    ariaCurrentText() {
      return this.isCurrentStep ? 'step' : null;
    },
    componentTag() {
      return this.stepUrl && this.isClickable ? 'a' : 'span';
    },
    componentAttrs() {
      return this.stepUrl && this.isClickable ? {href: this.stepUrl} : {};
    },
  },
  mounted() {
    this.computeStepIndex();
  },
  methods: {
    computeStepIndex() {
      this.indexData = Array.from(this.$el.parentNode.children).indexOf(this.$el);
    },
    updateCurrentStep() {
      if (this.isClickable) {
        this.steps.currentStep = this.index;
      }
    },
  },
};
</script>

<style lang="scss">
@import 'Steps.scss';
</style>
